  <div class="row excpBlock">
    <!-- Finra Summary Exception Count -->
      <div class="col-lg-12 nopadding">
        <div class="excp-Summary-widget">
          @if(isSummaryDataLoading){
          <div class="example-loading-shade">
            <mat-spinner diameter="50"></mat-spinner>
          </div>
          }
          @for(item of exceptionCodesSummaryBlocks; track item.failureCode + '-'+ $index; let i = $index) {
          <ul class="nopadding">
            <li>
              <a class="excpCodeBlockLink" (click)="getExceptionData(item.failureCode, true);">
                <div [ngClass]="{'optedExcpCode': (selectedExceptionCode && selectedExceptionCode===item.failureCode), 'excpCodeBlock': !item.isNamedErrorCode, 'namedExcpCodeBlock': item.isNamedErrorCode}">
                  <div class="text-center">
                    <div [ngClass]="{'excpCode': !item.isNamedErrorCode, 'namedExcpCode': item.isNamedErrorCode}">
                      <strong>{{item.failureCode}}</strong>
                    </div>
                    <div class="excpCount">
                      <Strong>{{item.totalCount | number}}</Strong>
                    </div>
                  </div>
                </div>
              </a>
            </li>
          </ul>
          }
        </div>
      </div>
    <!-- End of Finra Summary Exception Count -->
    <div class="col-lg-12 nopadding">&nbsp;</div>
      <!-- Finra Summary Exception brief Details -->
        <div class="col-lg-12 nopadding">
          @if(isDataLoading){
          <div class="example-loading-shade">
            <mat-spinner></mat-spinner>
          </div>
          }
          <p-table 
            alwaysShowPaginator="true" 
            paginatorPosition="both" 
            showCurrentPageReport="true"
            [value]="excpSummaryDataSet" 
            [columns]="excpSummaryCols" 
            [resizableColumns]="true" 
            columnResizeMode="expand"
            [totalRecords]="excpSummaryTotalRecords" 
            [paginator]="true"
            appendTo="body"
            (onPage)="changePage($event)"
            (onSort)="sort($event)" 
            sortMode="multiple"
            [rows]="constantService.DEFAULT_ROWSIZE" 
            [pageLinks]="constantService.DEFAULT_PAGELINKS"
            [rowsPerPageOptions]="constantService.DEFAULT_ROWSPERPAGEOPTION" 
            [lazy]="true" 
            [scrollable]="true" 
            scrollHeight="70vh"
            styleClass ="tableData summaryTable"
            #dt>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="columns.length">
                  {{tbldatamsg}}
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="header" let-columns>
              <tr>
                @for(col of columns; track col.header + '-'+ $index) {
                <th id="columns" pResizableColumn [pSortableColumn]="col.field"
                  [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay' : '' ">
                  {{col.header}}
                  <p-sortIcon [field]="col.field"></p-sortIcon>
                </th>
                }
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="ri">
              <tr [ngClass]="'ui-widget-NoUpdated-row'">
                @for(col of columns; track col.field + '-'+ $index) {
                <td class="ui-resizable-column"
                  [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
                  <!-- set String -->
                    <div class="text-center">
                      @if(['actual value', 'total exception count'].includes(col.header | lowercase)){
                        <span>
                          <a [matTooltip]="'View Finra Exceptions'" [matTooltipShowDelay]="1000" appendTo="body" (click)="onDisplayOrderDetail('Open-Finra-Exception-Detail-Screen', row)" class="orderIdLink">{{row[col.field]}}</a>
                        </span>
                      }
                      @if(!['actual value', 'total exception count'].includes(col.header | lowercase)){
                      <span>{{row[col.field]}}</span>
                      }
                    </div>
                </td>
                }
              </tr>
            </ng-template>
            <ng-template pTemplate="paginatorright">
              <app-export-to-csv [gridColumns]="excpSummaryExportableGridColumns" (exportToCSVListner)="exportToCSV($event)"></app-export-to-csv>
              Total Records: {{excpSummaryDataSet.length == 0 ? 0 : excpSummaryTotalRecords}}
            </ng-template>
            <ng-template pTemplate="paginatorleft">
              <!-- Page No : {{pageNumber }} -->
              Showing {{excpSummaryDataSet.length == 0 ? 0 : startLimit + 1}} to {{excpSummaryDataSet.length
                  < rowcount ? excpSummaryDataSet.length < startLimit ? endLimit : excpSummaryDataSet.length : endLimit}} entries
                </ng-template>
          </p-table>
        </div>
      <!-- End of Finra Summary Exception brief Details -->
  </div>